import styled, { css } from 'styled-components';
import { COLORS, DEVICES } from '@/theme';
import { Button, InputNumber } from '@/ui';

export const StyledWrapper = styled.div<{
  $limitReached?: boolean;
}>`
  display: inline-flex;
  justify-content: space-between;
  padding: 0.5rem;
  align-items: center;
  width: 100%;
  height: 2.75rem;
  transition: background-color 0.2s ease-in-out;
  border-radius: 0.25rem;

  @media screen and ${DEVICES.MOBILE_L} {
    gap: 0.375rem;
    padding: 0;
  }

  ${({ $limitReached }) => {
    if ($limitReached) {
      return css`
        background-color: ${COLORS.LIGHT_GRAY};
        color: ${COLORS.IRON_GRAY};
      `;
    }
    return css`
      border: 1px solid ${COLORS.BLACK_PRIMARY};
      background-color: ${COLORS.WHITE};
      color: ${COLORS.BLACK_PRIMARY};
      :hover {
        border: 0;
        background-color: ${COLORS.YELLOW_PRIMARY};

        .ant-input-number {
          background-color: ${COLORS.YELLOW_PRIMARY};
        }
      }
    `;
  }}
`;

export const StyledButton = styled(Button)`
  height: 1.5rem !important;
  width: 1.5rem;
  background: transparent !important;
  border: 0px !important;

  &&& .anticon {
    transform: none;
  }

  &&&.ant-btn-dangerous {
    color: ${COLORS.RED};

    &:disabled {
      color: rgba(236 33 40 / 10%);
    }
  }

  &:not(.ant-btn-dangerous):disabled {
    color: ${COLORS.DARK_GRAY} !important;
  }
`;

export const StyledInput = styled(InputNumber)<{ $limitReached?: boolean }>`
  &&& {
    width: 100%;
    border: none;
    padding: auto;

    .ant-input-number-handler-wrap {
      display: none;
    }
    ${({ $limitReached }) => $limitReached && `background-color: ${COLORS.LIGHT_GRAY};`}
  }

  &&& .ant-input-number {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.375rem;
  }

  &&& .ant-input-number-input {
    width: 100%;
    text-align: center;
  }
`;
